import fetch from '../utils/fetch'

export function getPlatformList (query) {
  return fetch({
    url: '/datacube/getPlatformList',
    method: 'get',
    params: query
  })
}
export function getPlatformTopList (query) {
  return fetch({
    url: '/datacube/getPlatformTopList',
    method: 'get',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/platform.js